import React, { useState, useCallback } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Form,
  Nav,
  Badge,
  Toast,
  ToastContainer,
  Overlay,
  Tooltip,
} from "react-bootstrap";
import { Bell, BellOff, Grid, List, Camera, Edit } from "react-feather";
import "bootstrap/dist/css/bootstrap.min.css";

export default function CreatedGroupPage() {
  const [activeTab, setActiveTab] = useState("members");
  const [viewMode, setViewMode] = useState("grid");
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [toast, setToast] = useState({ show: false, message: "" });
  const [isGroupCreator, setIsGroupCreator] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const targetRef = React.useRef(null);
  const [loading, setLoading] = useState(false);

  const toggleSubscription = useCallback(() => {
    setIsSubscribed((prev) => !prev);
    setToast({
      show: true,
      message: isSubscribed
        ? "Unsubscribed from group notifications"
        : "Successfully subscribed to group notifications!",
    });
  }, [isSubscribed]);

  const handlePhotoChange = (type) => {
    console.log(`Changing ${type} photo`);
    setToast({
      show: true,
      message: `${type.charAt(0).toUpperCase() + type.slice(1)} photo updated successfully!`,
    });
  };

  return (
    <div className="min-vh-100 bg-light">
      {/* Cover Photo */}
      <div className="position-relative" style={{ height: "300px" }}>
        <img
          src="https://example.com/image.jpg"
          alt="Group cover"
          style={{ width: "100%", height: "auto", objectFit: "cover" }}
        />
        {isGroupCreator && (
          <Button
            variant="light"
            className="position-absolute bottom-0 end-0 m-3"
            onClick={() => handlePhotoChange("cover")}
          >
            <Camera size={20} className="me-2" />
            Change Cover
          </Button>
        )}
      </div>

      <Container className="position-relative">
        {/* Group Info Section */}
        <Card className="shadow-sm" style={{ marginTop: "-100px" }}>
          <Card.Body>
            <Row className="align-items-end">
              <Col sm={8} className="d-flex gap-4">
                <div
                  className="position-relative"
                  style={{ marginTop: "-50px" }}
                >
                  <Card
                    className="shadow"
                    style={{ width: "150px", height: "150px" }}
                  >
                    <Card.Body className="d-flex align-items-center justify-content-center bg-primary text-white rounded">
                      <h1>R</h1>
                    </Card.Body>
                  </Card>
                  {isGroupCreator && (
                    <Button
                      variant="light"
                      className="position-absolute bottom-0 end-0 m-1"
                      style={{ padding: "0.25rem" }}
                      onClick={() => handlePhotoChange("group")}
                    >
                      <Camera size={16} />
                    </Button>
                  )}
                </div>
                <div>
                  <div className="d-flex align-items-center gap-2">
                    <h1 className="mb-0">R Programming</h1>
                    <Badge bg="primary" className="rounded-pill">
                      Group
                    </Badge>
                  </div>
                  <p className="text-muted mb-0">
                    Public • Active a minute ago
                  </p>
                </div>
              </Col>
              <Col sm={4} className="d-flex justify-content-end gap-2">
                {isGroupCreator ? (
                  <Button
                    variant="outline-primary"
                    className="d-flex align-items-center gap-2"
                    ref={targetRef}
                    onClick={() => setShowTooltip(!showTooltip)}
                  >
                    <Edit size={20} />
                    Edit Group
                  </Button>
                ) : (
                  <Button
                    variant={
                      isSubscribed ? "outline-secondary" : "outline-primary"
                    }
                    className="d-flex align-items-center gap-2"
                    onClick={toggleSubscription}
                  >
                    {isSubscribed ? (
                      <>
                        <BellOff size={20} />
                      </>
                    ) : (
                      <>
                        <Bell size={20} />
                      </>
                    )}
                  </Button>
                )}
              </Col>
            </Row>
          </Card.Body>
        </Card>

        {/* Navigation */}
        <Nav
          variant="tabs"
          className="mt-4"
          activeKey={activeTab}
          onSelect={(k) => k && setActiveTab(k)}
        >
          <Nav.Item>
            <Nav.Link
              eventKey="members"
              className="d-flex align-items-center gap-2"
            >
              Members
              <Badge bg="primary" pill>
                1
              </Badge>
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="feed">Feed</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="photos">Photos</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="albums">Albums</Nav.Link>
          </Nav.Item>
          {isGroupCreator && (
            <>
              <Nav.Item>
                <Nav.Link eventKey="invites">Send Invites</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="manage">Manage</Nav.Link>
              </Nav.Item>
            </>
          )}
        </Nav>

        {/* Search and View Toggle */}
        <Row className="mt-4 align-items-center">
          <Col>
            <Form.Control
              type="search"
              placeholder="Search Members..."
              className="w-auto"
            />
          </Col>
          <Col xs="auto">
            <Button
              variant="outline-secondary"
              className="me-2"
              active={viewMode === "grid"}
              onClick={() => setViewMode("grid")}
            >
              <Grid size={20} />
            </Button>
            <Button
              variant="outline-secondary"
              active={viewMode === "list"}
              onClick={() => setViewMode("list")}
            >
              <List size={20} />
            </Button>
          </Col>
        </Row>

        {/* Organizers Section */}
        <div className="mt-4">
          <h2 className="mb-3">Organizers</h2>
          <Row>
            <Col md={4}>
              <Card className="shadow-sm hover-shadow transition-all">
                <Card.Body className="text-center">
                  <div className="mb-3">
                    <div
                      className="rounded-circle bg-secondary text-white d-flex align-items-center justify-content-center mx-auto"
                      style={{ width: "80px", height: "80px" }}
                    >
                      <h2>D</h2>
                    </div>
                  </div>
                  <h4>Dustin</h4>
                  <p className="text-muted mb-1">Joined 2 minutes ago</p>
                  <div className="d-flex align-items-center justify-content-center gap-2">
                    <span
                      className="bg-success rounded-circle"
                      style={{ width: "8px", height: "8px" }}
                    ></span>
                    Active now
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>
      </Container>

      {/* Toast Notifications */}
      <ToastContainer position="bottom-end" className="p-3">
        <Toast
          show={toast.show}
          onClose={() => setToast({ ...toast, show: false })}
          delay={3000}
          autohide
        >
          <Toast.Header>
            <strong className="me-auto">Notification</strong>
          </Toast.Header>
          <Toast.Body>{toast.message}</Toast.Body>
        </Toast>
      </ToastContainer>

      {/* Tooltip for Edit Group button */}
      <Overlay target={targetRef.current} show={showTooltip} placement="bottom">
        {(props) => (
          <Tooltip id="edit-group-tooltip" {...props}>
            As the group creator, you can edit group details, manage members,
            and change group settings.
          </Tooltip>
        )}
      </Overlay>

      <style jsx global>{`
        .hover-shadow:hover {
          transform: translateY(-2px);
          box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
        }

        .transition-all {
          transition: all 0.2s ease-in-out;
        }

        .nav-tabs .nav-link {
          color: #6c757d;
          border: none;
          padding: 1rem 1.5rem;
          font-weight: 500;
        }

        .nav-tabs .nav-link.active {
          color: #0d6efd;
          border-bottom: 2px solid #0d6efd;
          background: none;
        }

        .form-control:focus {
          box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
          border-color: #86b7fe;
        }
      `}</style>
    </div>
  );
}
